import { useContext } from 'react';
import { useDispatch } from 'react-redux';
import { Alert, AlertTitle } from '@mui/material';
import {
  Icon,
  Dialog,
  TextColor,
  ButtonColors,
  ThemeContext,
  StandardButton,
  ButtonStyleTypes,
} from '@gv/triage-components';

import { setCallFlowInProgress } from 'store/slices/analytics-export';

import { CallContext } from '../context';

import { SubmitCaseProps } from './types';

export const SubmitCaseDialog = ({
  isCall,
  isVideo,
  setOpen,
  onSubmit,
  ...props
}: SubmitCaseProps) => {
  const { form, isCallTransferred } = useContext(CallContext);
  const { isDarkTheme } = useContext(ThemeContext);
  const dispatch = useDispatch();

  return (
    <Dialog
      title="Submit case"
      closeOnEscape={false}
      icon={<Icon.Completed />}
      iconColor={TextColor.Green}
      closeOnDocumentClick={false}
      text={
        <>
          Are you sure you want to submit case with{' '}
          <span className="semibold">
            {form?.values?.client?.name ?? form?.values?.client_name}
          </span>
          ?
        </>
      }
      buttons={(close) => (
        <>
          {isCallTransferred ? (
            <StandardButton
              fullWidth
              text="Submit case"
              colorType={ButtonColors.Secondary}
              onClick={() => {
                close();
                setOpen(false);
                onSubmit(false);
              }}
            />
          ) : (
            <StandardButton
              fullWidth
              text={`Submit case and end ${isCall ? 'call' : isVideo ? 'video' : 'chat'}`}
              onClick={async () => {
                close();
                setOpen(false);
                onSubmit(true);
                localStorage.setItem('callFlowInProgress', 'false');
                dispatch(setCallFlowInProgress(false));
              }}
            />
          )}

          <StandardButton
            fullWidth
            text="Cancel"
            styleType={ButtonStyleTypes.Outline}
            onClick={() => {
              close();
              setOpen(false);
            }}
          />
          {!isCall && !isVideo && (
            <Alert
              severity="error"
              variant="outlined"
              sx={{
                borderRadius: '8px',
                color: isDarkTheme ? '#F9F9F9' : '#d32f2f',
                bgcolor: isDarkTheme ? 'rgb(62, 43, 43)' : 'background.paper',
                border: isDarkTheme
                  ? '1px solid rgb(200, 32, 32)'
                  : '1px solid #d32f2f',
                '& .MuiAlert-icon': {
                  color: isDarkTheme ? 'rgb(200, 32, 32)' : '#d32f2f',
                },
              }}
            >
              <AlertTitle>Note</AlertTitle>
              You must enter all required information and submit the case before
              ending the chat.
            </Alert>
          )}
        </>
      )}
      {...props}
    />
  );
};
